// src/components/TabName.js (o donde lo tengas guardado)
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TabName = () => {
  const location = useLocation();

  useEffect(() => {
    let title = 'KAIROS | Weather Platform';
    let description = 'AIMethods high-precision aviation weather forecast map.';
    
    const path = location.pathname;

    // --- LÓGICA SWEDAVIA ---
    if (path.includes('/swedavia')) {
      if (path.includes('dashboard')) {
        title = 'SWEDAVIA | Forecast Dashboard';
        description = 'Real-time freezing fog predictions for Swedavia airports.';
      } else if (path.includes('analytics')) {
        title = 'SWEDAVIA | Analytics';
        description = 'Historical performance analysis and metrics.';
      } else {
        // Probablemente sea el Login
        title = 'SWEDAVIA | Login';
        description = 'Login to Swedavia Forecast Platform.';
      }
    } 
    // --- LÓGICA KAIROS (y Legacy) ---
    else {
      // Usamos .endsWith o .includes para atrapar tanto "/weather-map" como "/kairos/weather-map"
      if (path.includes('weather-map')) {
        title = 'KAIROS | LiveDemo';
        description = 'AIMethods high-precision aviation weather forecast map.';
      } 
      else if (path.includes('performance')) {
        title = 'KAIROS | Performance';
        description = 'Visualisation of performance and comparative metrics.';
      } 
      else if (path.includes('analytics')) {
        title = 'KAIROS | Analytics';
        description = 'Performance visualisation and comparative metrics.';
      } 
      else if (path.includes('forecast-metrics')) {
        title = 'KAIROS | AI Metrics';
        description = 'Forecast metrics visualisation.';
      }
      else if (path.includes('contrail')) {
        title = 'KAIROS | Contrail';
        description = 'Contrail avoidance and prediction.';
      }
    }

    // Aplicar cambios
    document.title = title;
    
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', description);
    }
  }, [location]);

  return null;
};

export default TabName;